var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "제품 및 솔루션",
      "sc": "에프원시큐리티는 다방면으로 파트너의 정보를 보호합니다",
      "tabActive": "F1 UWSS",
      "icon": "/images/sub/visual/sv3-icon.svg",
      "bg": "/images/sub/visual/sv3.png"
    }
  }), _c('section', {
    staticClass: "sub-section-sm sub-section-sm--first",
    attrs: {
      "id": "uwss"
    }
  }, [_c('v-container', [_c('h3', {
    staticClass: "sub-tit--lg text-center mb-28 mb-lg-54",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" F1Security는 웹 해킹 예방, 탐지, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 대응 제품을 개발하여 제공합니다. ")]), _c('div', {
    staticClass: "w-100 pa-30 pa-md-70 mb-40 mb-lg-80 bg-grey-full"
  }, [_c('v-img', {
    staticClass: "tb mx-auto mb-28 mb-lg-60",
    attrs: {
      "max-width": "961",
      "src": "/images/sub/products/uwss/s1-img1.png"
    }
  }), _c('v-img', {
    staticClass: "mo mx-auto mb-28 mb-lg-60",
    attrs: {
      "max-width": "511",
      "src": "/images/sub/products/uwss/s1-img1-mo.png"
    }
  }), _c('v-img', {
    staticClass: "tb mx-auto",
    attrs: {
      "max-width": "961",
      "src": "/images/sub/products/uwss/s1-img2.png"
    }
  }), _c('v-img', {
    staticClass: "mo mx-auto",
    attrs: {
      "max-width": "510",
      "src": "/images/sub/products/uwss/s1-img2-mo.png"
    }
  })], 1), _c('div', {
    staticClass: "w-100 d-flex flex-column flex-lg-row radius dep2-process-group dep2-process-group1 mb-28 mb-lg-40"
  }, [_c('div', {
    staticClass: "dep2-process dep2-process1 d-lg-flex align-center justify-center pa-16 pa-md-32 py-lg-40"
  }, [_c('div', [_c('p', {
    staticClass: "font-size-14 font-size-lg-18 font-weight-bold color-white line-height-1 mb-6 mb-lg-14"
  }, [_vm._v(" 이슈 ")]), _c('p', {
    staticClass: "page-text color-white"
  }, [_vm._v(" 웹 보안 해결을 위한 고객의 제품 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 선택이 어려움, 시스템 복잡도 증대 ")])])]), _c('div', {
    staticClass: "dep2-process-arrow d-flex align-center justify-center bg-grey py-16 py-lg-0"
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "38",
      "src": "/images/sub/products/uwss/process-arrow.png"
    }
  })], 1), _c('div', {
    staticClass: "dep2-process dep2-process2 pa-16 pa-md-32 pl-lg-60 py-lg-40"
  }, [_c('div', [_c('p', {
    staticClass: "color-point font-size-14 font-size-lg-18 font-weight-bold line-height-1 mb-6 mb-lg-14"
  }, [_vm._v(" 해결 방안 ")]), _c('p', {
    staticClass: "page-text color-grey-57"
  }, [_vm._v(" 고객은 UWSS 단일 서비스 선택만으로 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 필수적인 다양한 웹 보안을 도입 ")])])])]), _c('div', {
    staticClass: "w-100 d-flex flex-column flex-lg-row radius dep2-process-group dep2-process-group2 mb-28 mb-lg-40"
  }, [_c('div', {
    staticClass: "dep2-process dep2-process1 d-lg-flex align-center justify-center pa-16 pa-md-32 py-lg-40"
  }, [_c('div', [_c('p', {
    staticClass: "font-size-14 font-size-lg-18 font-weight-bold color-white line-height-1 mb-6 mb-lg-14"
  }, [_vm._v(" 이슈 ")]), _c('p', {
    staticClass: "page-text color-white"
  }, [_vm._v(" 많은 기업에는 웹 보안 전문 지식과 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 경험을 보유한 전문가 부재 ")])])]), _c('div', {
    staticClass: "dep2-process-arrow d-flex align-center justify-center bg-grey py-16 py-lg-0"
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "38",
      "src": "/images/sub/products/uwss/process-arrow.png"
    }
  })], 1), _c('div', {
    staticClass: "dep2-process dep2-process2 pa-16 pa-md-32 pl-lg-60 py-lg-40"
  }, [_c('div', [_c('p', {
    staticClass: "color-point font-size-14 font-size-lg-18 font-weight-bold line-height-1 mb-6 mb-lg-14"
  }, [_vm._v(" 해결 방안 ")]), _c('p', {
    staticClass: "page-text color-grey-57"
  }, [_vm._v(" 클라우드 중앙관리시스템의 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 직관적인 UI를 사용한 운영관리 ")])])])]), _c('div', {
    staticClass: "w-100 d-flex flex-column flex-lg-row radius dep2-process-group dep2-process-group3 mb-28 mb-lg-40"
  }, [_c('div', {
    staticClass: "dep2-process dep2-process1 d-lg-flex align-center justify-center pa-16 pa-md-32 py-lg-40"
  }, [_c('div', [_c('p', {
    staticClass: "font-size-14 font-size-lg-18 font-weight-bold color-white line-height-1 mb-6 mb-lg-14"
  }, [_vm._v(" 이슈 ")]), _c('p', {
    staticClass: "page-text color-white"
  }, [_vm._v(" 웹 보안 제품 도입이 절실한 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 대다수 기업에게는 너무 고가 ")])])]), _c('div', {
    staticClass: "dep2-process-arrow d-flex align-center justify-center bg-grey py-16 py-lg-0"
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "38",
      "src": "/images/sub/products/uwss/process-arrow.png"
    }
  })], 1), _c('div', {
    staticClass: "dep2-process dep2-process2 pa-16 pa-md-32 pl-lg-60 py-lg-40"
  }, [_c('div', [_c('p', {
    staticClass: "color-point font-size-14 font-size-lg-18 font-weight-bold line-height-1 mb-6 mb-lg-14"
  }, [_vm._v(" 해결 방안 ")]), _c('p', {
    staticClass: "page-text color-grey-57"
  }, [_vm._v(" 소프트웨어 & 클라우드 기반 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 합리적인 가격체계로 도입 가능 ")])])])])])], 1), _c('section', {
    staticClass: "sub-section-sm"
  }, [_c('v-container', [_c('h4', {
    staticClass: "sub-tit--md text-center mb-26 mb-lg-42",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" UWSS는 차별화 요소로 고객에게 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 다양한 가치를 제공합니다 ")]), _c('div', {
    staticClass: "client-table"
  }, [_c('div', {
    staticClass: "thead d-none d-lg-block"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "th"
  }, [_vm._v("고객가치")]), _c('div', {
    staticClass: "th color-point"
  }, [_vm._v("차별화 요소")]), _c('div', {
    staticClass: "th"
  }, [_vm._v("유사 제품")])])]), _c('div', {
    staticClass: "tbody"
  }, [_c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "td"
  }, [_vm._v(" 통합 서비스 ")]), _c('div', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "d-block d-lg-none"
  }, [_vm._v("차별화 요소")]), _vm._v(" 통합 운영관리 가능한 웹 보안 종합솔루션 제공 "), _c('br'), _vm._v(" ※ 고객 선택에 따른 맞춤형 서비스 ")]), _c('div', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "d-block d-lg-none"
  }, [_vm._v("유사 제품")]), _vm._v(" 개별 제품 각각 구매, 개별 제품 각각 관리로 편의성 저하 ")])]), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "td"
  }, [_vm._v(" 서버구축 비용절감 ")]), _c('div', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "d-block d-lg-none"
  }, [_vm._v("차별화 요소")]), _vm._v(" 클라우드에 통합 중앙관리 플랫폼을 구축하여 제공 "), _c('br'), _vm._v(" ※ 고객 서버 구축/운영 비용 Zero ")]), _c('div', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "d-block d-lg-none"
  }, [_vm._v("유사 제품")]), _vm._v(" 관리서버 구매 및 구축, 운영비용 발생 ")])]), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "td"
  }, [_vm._v(" 즉각적인 설치운영 ")]), _c('div', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "d-block d-lg-none"
  }, [_vm._v("차별화 요소")]), _vm._v(" Agent 소프트웨어 다운로드/설치 후 "), _c('br'), _vm._v(" 즉시 사용 가능 ")]), _c('div', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "d-block d-lg-none"
  }, [_vm._v("유사 제품")]), _vm._v(" SECaaS(Proxy 방식)은 DNS 변경/적용 등 시간소요 ")])]), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "td"
  }, [_vm._v(" 운영관리 효율성 ")]), _c('div', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "d-block d-lg-none"
  }, [_vm._v("차별화 요소")]), _vm._v(" 단일 관리용 웹사이트를 통한 통합 운영관리 가능 "), _c('br'), _vm._v(" ※ 복수 제품을 단일 창구로 계약/관리(업무 효율화) ")]), _c('div', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "d-block d-lg-none"
  }, [_vm._v("유사 제품")]), _vm._v(" 개별 제품 관리시스템 제공 ")])]), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "td"
  }, [_vm._v(" 사용자 편의성 ")]), _c('div', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "d-block d-lg-none"
  }, [_vm._v("차별화 요소")]), _vm._v(" 통합 대시보드, 통합 보고서 등 보안관리 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 편의성 증대 ")]), _c('div', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "d-block d-lg-none"
  }, [_vm._v("유사 제품")]), _vm._v(" 미 제공, 개별 제품 대시보드/보고서 ")])]), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "td"
  }, [_vm._v(" 장애 시 웹 접속 보장 ")]), _c('div', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "d-block d-lg-none"
  }, [_vm._v("차별화 요소")]), _vm._v(" 플랫폼, Agent 장애에 따른 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 고객 웹 접속 영향 없음 ")]), _c('div', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "d-block d-lg-none"
  }, [_vm._v("유사 제품")]), _vm._v(" SECaaS(Proxy 방식)은 서비스 인프라 장애 시 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 고객 웹사이트 접속도 중단 ")])]), _c('div', {
    staticClass: "tr"
  }, [_c('div', {
    staticClass: "td"
  }, [_vm._v(" 해킹 시 안전한 플랫폼 ")]), _c('div', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "d-block d-lg-none"
  }, [_vm._v("차별화 요소")]), _vm._v(" 클라우드 플랫폼은 어떠한 웹 트래픽도 우회, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 저장하지 않기 때문에, 플랫폼이 해킹되어도 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 정보유출 미 발생 ")]), _c('div', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "d-block d-lg-none"
  }, [_vm._v("유사 제품")]), _c('div', {
    staticClass: "bar-txt"
  }, [_vm._v(" - SECaaS(Proxy 방식)은 서비스 인프라에 모든 웹 트래픽 우회 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 분석/저장(가능) "), _c('br', {
    staticClass: "d-none d-lg-block"
  })]), _c('div', {
    staticClass: "bar-txt"
  }, [_vm._v(" - 인프라 장애 시 트래픽 정보도 유출 가능 ")])])])])])])], 1), _c('section', {
    staticClass: "sub-section-sm sub-section--last"
  }, [_c('v-container', [_c('h3', {
    staticClass: "sub-tit--md text-center mb-26 mb-lg-42",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 웹 보안 및 클라우드 중앙관리시스템을 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" One 플랫폼 One 서비스로 제공합니다. ")]), _c('div', {
    staticClass: "radius-md border mb-40 mb-lg-80"
  }, [_c('p', {
    staticClass: "w-100 bg-point color-white text-center font-weight-bold font-size-16 font-size-lg-22 line-height-1 pa-18"
  }, [_vm._v(" 웹보안 서비스 ")]), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "service-item",
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column align-center justify-center py-24 px-16"
  }, [_c('div', {
    staticClass: "bg-grey radius-md d-flex align-center justify-center mb-6 mb-lg-14",
    staticStyle: {
      "width": "70px",
      "height": "70px"
    }
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "46",
      "src": "/images/sub/products/uwss/s3-icon1-1.png"
    }
  })], 1), _c('p', {
    staticClass: "font-size-16 font-size-lg-22 text-center line-height-1 font-weight-700"
  }, [_vm._v(" 웹 방화벽 ")])]), _c('div', {
    staticClass: "service-item-option pa-16 bg-grey"
  }, [_c('p', {
    staticClass: "color-point font-size-14 font-size-lg-18 line-height-1 text-center"
  }, [_vm._v(" Software Agent ")])]), _c('div', {
    staticClass: "pa-16 pa-lg-34"
  }, [_c('p', {
    staticClass: "page-text-sm color-gray bar-txt mb-10 mb-lg-24"
  }, [_vm._v(" - OWASP Top 10 웹 어플리케이션 공격 탐지 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 및 차단 "), _c('br'), _vm._v(" ※ 탐지Only 모드, Blocking 모드 선택 가능 ")]), _c('p', {
    staticClass: "page-text-sm color-gray bar-txt"
  }, [_vm._v(" - 사용자 정의 규칙 작성, IP/Domain 예외 처리, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" Parameter Block ")])])]), _c('v-col', {
    staticClass: "service-item",
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column align-center justify-center py-24 px-16"
  }, [_c('div', {
    staticClass: "bg-grey radius-md d-flex align-center justify-center mb-6 mb-lg-14",
    staticStyle: {
      "width": "70px",
      "height": "70px"
    }
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "46",
      "src": "/images/sub/products/uwss/s3-icon1-2.png"
    }
  })], 1), _c('p', {
    staticClass: "font-size-16 font-size-lg-22 text-center line-height-1 font-weight-700"
  }, [_vm._v(" 안티 웹쉘 ")])]), _c('div', {
    staticClass: "service-item-option pa-16 bg-grey"
  }, [_c('p', {
    staticClass: "color-point font-size-14 font-size-lg-18 line-height-1 text-center"
  }, [_vm._v(" Software Agent ")])]), _c('div', {
    staticClass: "pa-16 pa-lg-34"
  }, [_c('p', {
    staticClass: "page-text-sm color-gray bar-txt mb-10 mb-lg-24"
  }, [_vm._v(" - 웹쉘 탐지 및 격리(+3,500개 이상의 탐지패턴) "), _c('br'), _vm._v(" ※ Regex, Hash, Url, SSDeep, obfuscation "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 알고리즘 적용 탐지 ")]), _c('p', {
    staticClass: "page-text-sm color-gray bar-txt"
  }, [_vm._v(" - 실시간 탐지 On/Off, 수동 검사 설정, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" Whitelist 등록 ")])])]), _c('v-col', {
    staticClass: "service-item",
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column align-center justify-center py-24 px-16"
  }, [_c('div', {
    staticClass: "bg-grey radius-md d-flex align-center justify-center mb-6 mb-lg-14",
    staticStyle: {
      "width": "70px",
      "height": "70px"
    }
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "46",
      "src": "/images/sub/products/uwss/s3-icon1-3.png"
    }
  })], 1), _c('p', {
    staticClass: "font-size-16 font-size-lg-22 text-center line-height-1 font-weight-700"
  }, [_vm._v(" 웹 악성코드 유포 탐지 ")])]), _c('div', {
    staticClass: "service-item-option pa-16 bg-grey"
  }, [_c('p', {
    staticClass: "color-point font-size-14 font-size-lg-18 line-height-1 text-center"
  }, [_vm._v(" Remote Scanning ")])]), _c('div', {
    staticClass: "pa-16 pa-lg-34"
  }, [_c('p', {
    staticClass: "page-text-sm color-gray bar-txt mb-10 mb-lg-24"
  }, [_vm._v(" - 악성코드 경유 및 유포지 URL 탐지 "), _c('br'), _vm._v(" (+175,500개 이상의 탐지패턴) ")]), _c('p', {
    staticClass: "page-text-sm color-gray bar-txt"
  }, [_vm._v(" - 정기 및 수동 검사 설정, Path Depth/Sub Page Link/ Navigation Page 설정 ")])])])], 1)], 1), _c('div', {
    staticClass: "radius-md border"
  }, [_c('p', {
    staticClass: "w-100 bg-point color-white text-center font-weight-bold font-size-16 font-size-lg-22 line-height-1 pa-18"
  }, [_vm._v(" 중앙관리 시스템 ")]), _c('v-row', {
    staticClass: "service-item-group_option1",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "service-item",
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column align-center justify-center py-24 px-16"
  }, [_c('div', {
    staticClass: "bg-grey radius-md d-flex align-center justify-center mb-6 mb-lg-14",
    staticStyle: {
      "width": "70px",
      "height": "70px"
    }
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "48",
      "src": "/images/sub/products/uwss/s3-icon2-1.png"
    }
  })], 1), _c('p', {
    staticClass: "font-size-16 font-size-lg-22 text-center line-height-1 font-weight-700"
  }, [_vm._v(" 설치 및 설정 ")])]), _c('div', {
    staticClass: "service-item-option pa-16 bg-grey"
  }, [_c('p', {
    staticClass: "color-point font-size-14 font-size-lg-18 line-height-1 text-center"
  }, [_vm._v(" Cloud ")])]), _c('div', {
    staticClass: "pa-16 pa-lg-34"
  }, [_c('p', {
    staticClass: "page-text-sm color-gray bar-txt"
  }, [_vm._v(" - Agent 다운로드, 등록, 보안 정책 조회 및 변경 ")])])]), _c('v-col', {
    staticClass: "service-item",
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column align-center justify-center py-24 px-16"
  }, [_c('div', {
    staticClass: "bg-grey radius-md d-flex align-center justify-center mb-6 mb-lg-14",
    staticStyle: {
      "width": "70px",
      "height": "70px"
    }
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "48",
      "src": "/images/sub/products/uwss/s3-icon2-2.png"
    }
  })], 1), _c('p', {
    staticClass: "font-size-16 font-size-lg-22 text-center line-height-1 font-weight-700"
  }, [_vm._v(" 통합 서비스 ")])]), _c('div', {
    staticClass: "service-item-option pa-16 bg-grey"
  }, [_c('p', {
    staticClass: "color-point font-size-14 font-size-lg-18 line-height-1 text-center"
  }, [_vm._v(" Cloud ")])]), _c('div', {
    staticClass: "pa-16 pa-lg-34"
  }, [_c('p', {
    staticClass: "page-text-sm color-gray bar-txt"
  }, [_vm._v(" - 통합 대시보드 조회, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 통합 보고서 조회 및 다운로드 ")])])]), _c('v-col', {
    staticClass: "service-item",
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column align-center justify-center py-24 px-16"
  }, [_c('div', {
    staticClass: "bg-grey radius-md d-flex align-center justify-center mb-6 mb-lg-14",
    staticStyle: {
      "width": "70px",
      "height": "70px"
    }
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "48",
      "src": "/images/sub/products/uwss/s3-icon2-3.png"
    }
  })], 1), _c('p', {
    staticClass: "font-size-16 font-size-lg-22 text-center line-height-1 font-weight-700"
  }, [_vm._v(" 로깅 및 알림 ")])]), _c('div', {
    staticClass: "service-item-option pa-16 bg-grey"
  }, [_c('p', {
    staticClass: "color-point font-size-14 font-size-lg-18 line-height-1 text-center"
  }, [_vm._v(" Cloud ")])]), _c('div', {
    staticClass: "pa-16 pa-lg-34"
  }, [_c('p', {
    staticClass: "page-text-sm color-gray bar-txt"
  }, [_vm._v(" - 탐지, 차단, 격리 등 보안이벤트 내역 로깅 및 실시간 이메일 알림 ")])])]), _c('v-col', {
    staticClass: "service-item",
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column align-center justify-center py-24 px-16"
  }, [_c('div', {
    staticClass: "bg-grey radius-md d-flex align-center justify-center mb-6 mb-lg-14",
    staticStyle: {
      "width": "70px",
      "height": "70px"
    }
  }, [_c('v-img', {
    staticClass: "d-block",
    attrs: {
      "max-width": "48",
      "src": "/images/sub/products/uwss/s3-icon2-4.png"
    }
  })], 1), _c('p', {
    staticClass: "font-size-16 font-size-lg-22 text-center line-height-1 font-weight-700"
  }, [_vm._v(" 마이 페이지 ")])]), _c('div', {
    staticClass: "service-item-option pa-16 bg-grey"
  }, [_c('p', {
    staticClass: "color-point font-size-14 font-size-lg-18 line-height-1 text-center"
  }, [_vm._v(" Cloud ")])]), _c('div', {
    staticClass: "pa-16 pa-lg-34"
  }, [_c('p', {
    staticClass: "page-text-sm color-gray bar-txt"
  }, [_vm._v(" - 사용자, 서비스 타입, 빌링 정보 등 조회, 등록 및 변경 ")])])])], 1)], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }